import { useCallback } from 'react'
import {
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	bigTagApi
} from 'interface/endpoints'
import {
	BigTagResult,
	BigTagResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListBigTag = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<BigTagResultList>(
        apiAccess,
				bigTagApi('/list', { t }),
        cancelToken
      )
    },
		[]
	)
)

export const useGetBigTag = (
	bigTagId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!bigTagId) return null
      return ApiGetWithToken<BigTagResult>(
        apiAccess,
				bigTagApi(`/${bigTagId}`, { t }),
        cancelToken
      )
    },
		[bigTagId]
	)
)
